<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>外单位用户</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="listParams.mobile" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh"> 查询 </el-button>
          <el-button size="small" @click="resetForm('listForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="dataLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <el-button size="small" type="primary" @click="handleAppend">添加外单位用户</el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

        <el-table-column prop="mobile" align="center" label="手机号" />
        <el-table-column prop="siteName" align="left" label="供应点" />

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.specialStatus == 2" type="text" @click="handleRemove(scope.row)">
              <span class="color-danger">移除该用户</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <DialogAppend :dialogVisible.sync="dialogVisible" @refresh="handleRefresh" />
  </div>
</template>

<script>
import Vue from "vue";
import DialogAppend from "./components/DialogAppend.vue";

export default {
  components: { DialogAppend },

  data() {
    return {
      listParams: { mobile: "", pageIndex: 1, pageSize: 15 },
      dataLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogVisible: false,
    };
  },

  mounted() {
    this.loadTableData();
  },

  methods: {
    handleRefresh() {
      this.listParams.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据
     */
    async loadTableData() {
      this.dataLoading = true;
      try {
        const response = await Vue.ajaxGet(this, global.apiUrl + "/supply/special/user/list", this.listParams, "dataLoading");
        this.tableData = response.content || [];
        this.pager.total = response.totalElements || 0;
        this.pager.pageSize = response.size || 0;
        this.pager.pageIndex = this.listParams.pageIndex || 1;
        this.dataLoading = false;
      } catch (error) {
        this.dataLoading = false;
      }
    },

    /**
     * 切换页码
     * @param pageIndex
     */
    handleCurrentChange(pageIndex) {
      this.listParams.pageIndex = pageIndex;
      this.loadTableData();
    },

    /**
     * 切换每页显示条数
     * @param pageSize
     */
    handleSizeChange(pageSize) {
      this.listParams.pageSize = pageSize;
      this.loadTableData();
    },

    /**
     * 重置表单
     * @param formName
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /**
     * 添加用户
     */
    handleAppend() {
      this.dialogVisible = true;
    },

    /**
     * 移除用户
     * @param row
     */
    async handleRemove(row) {
      try {
        await Vue.ajaxPost(this, global.apiUrl + "/supply/add/special", { id: row.id, specialStatus: 1 }, "dataLoading");
        this.$message.success("操作成功");
        this.handleRefresh();
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
